import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=54f9cdbd&"
import script from "./PromotionList.vue?vue&type=script&lang=js&"
export * from "./PromotionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports